<script>
import inputMixin from '@/site/site/common/mixin_input'
export default {
	lang: 'shop',
	mixins: [inputMixin],
	props: {
		countryId: Number,
		label: String,
	},
	model: {
		prop: 'countryId',
		event: 'updateModel',
	},
	data() {
		return {
			loading: false,
			countries: [],
			defaultCountryId: null,
		}
	},
	computed: {
		cLabel() {
			return this.label || this.$lang('Cód. País')
		},
	},
	methods: {
		async loadData() {
			await this.$shopApi.get({
				url: '/user/phone-countries',
				loading: (v) => (this.loading = v),
				onSuccess: ({ data }) => {
					this.countries = data.countries.map((country) => ({
						text: `(+${country.phoneCode}) ${country.name}`,
						value: country.id,
					}))
					if (!this.countryId && data.defaultCountryId) {
						this.$emit('updateModel', data.defaultCountryId)
					}
				},
				cache: true,
			})
		},
		onInput($event) {
			this.$emit('updateModel', $event)
		},
		focus() {
			this.$refs.selector.focus()
		},
	},
	created() {
		this.loadData()
	},
}
</script>

<template>
	<Autocomplete
		ref="selector"
		:label="cLabel"
		:placeholder="$lang('Buscar...')"
		@input="onInput"
		:items="countries"
		:multiple="false"
		:loading="loading"
		:no-data-text="$lang('No se han encontrado resultados...')"
		:hide-no-data="loading"
		:value="countryId"
		:error-messages="validationErrors"
		v-bind="$attrs"
	/>
</template>
